var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0a6 6 0 014.891 9.476l4.816 4.817-1.414 1.414-4.817-4.816A6 6 0 116 0zm0 2C3.79 2 2 3.79 2 6s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iIzAwNmVhZCI+CiAgICA8cGF0aCBkPSJNNiAwYTYgNiAwIDAxNC44OTEgOS40NzZsNC44MTYgNC44MTctMS40MTQgMS40MTQtNC44MTctNC44MTZBNiA2IDAgMTE2IDB6bTAgMkMzLjc5IDIgMiAzLjc5IDIgNnMxLjc5IDQgNCA0IDQtMS43OSA0LTQtMS43OS00LTQtNHoiIGZpbGw9IiMwMDZlYWQiIC8+Cjwvc3ZnPgo=";
export { SvgSearch as ReactComponent };